import { render } from "./SiloPage.vue?vue&type=template&id=e820d69c"
import script from "./SiloPage.vue?vue&type=script&lang=js"
export * from "./SiloPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__